module.exports = __webpack_public_path__ + "img/8diamonds.af59930a.jpg";